<template>
	<div>
		<DialogHeader @cancel="$emit('accept')" />
		<DialogBody class="mt-6">
			<Cover class="rounded-4" width="100%" height="157px" :src="image" />
			<h3 class="text-neutral-900 text-title-m mt-5">{{ title }}</h3>
			<p class="text-neutral-900 text-body-xl mt-2">{{ description }}</p>
		</DialogBody>
		<DialogActions
			:accept-action="{ text: buttonText }"
			accept-classes="accept-feature"
			@accept="$emit('accept')"
		/>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		title: string
		description: string
		image: string
		buttonText: string
		isXS: boolean
	}
	defineProps<Props>()
	defineEmits(['accept'])
</script>

<style lang="scss">
	.accept-feature {
		width: 100% !important;
	}
</style>
